import { api } from './api';
import type { AiStatsOverview } from '../types';

export const aiStatsApi = {
  get: (days = 7) => api.get<AiStatsOverview>(`/stats/ai?days=${days}`),
};
